<template>
  <div class="ps-update-page" :class="{ 'is-ai-parsing': jxing }">
    <AiParseLoading
      v-if="jxing"
      title="正在智能识别思政微课申报书"
      @cancel="cancelAiParse"
    />
    <!-- 识别中不挂载重表单，避免与遮罩叠层导致页面卡死 -->
    <div v-if="!jxing" class="ps-form-layout">
      <aside class="ps-sidebar">
        <div class="ps-side-card">
          <div class="ps-side-title">填写步骤</div>
          <button
            v-for="(sec, i) in sections"
            :key="sec.id"
            type="button"
            class="ps-step-item"
            :class="sectionStepClass(i)"
            @click="editGo(i)"
          >
            <span class="ps-step-label">{{ sec.title }}</span>
            <span class="ps-step-mark">{{ sectionStepMark(i) }}</span>
          </button>
          <div class="ps-side-hint">
            点击步骤切换模块，带 <b style="color: #ef4444">*</b> 的为必填项
          </div>
        </div>
      </aside>

      <div class="ps-content">
        <div class="ps-status-bar">
          <div class="ps-status-block">
            <span class="ps-status-label">当前状态</span>
            <StatusBadge status="0" text="AI导入" type="blue" />
          </div>
          <div class="ps-status-block">
            <span class="ps-status-label">正在编辑</span>
            <span class="ps-status-value warn">识别结果编辑</span>
          </div>
          <div style="flex: 1"></div>
          <button type="button" class="ps-btn ps-btn--white" @click="saveDraft">
            💾 暂存
          </button>
          <button type="button" class="ps-btn ps-btn--blue" @click="option()">
            ✉ 提交
          </button>
          <button type="button" class="ps-btn ps-btn--white" @click="goBack">
            ↩ 返回
          </button>
        </div>

        <div
          class="ps-form-card"
          :class="{ 'is-origin-form': activeSection === 0 }"
        >
          <div v-show="activeSection === 0" id="baseInfo" class="ps-origin-base-embed">
            <BaseInfo
              :oldInfos="baseInfo"
              ref="baseInfoRef"
              :isbj="isbjs"
              @goStep="goStep"
              :isAdd="isAdd"
            />
          </div>
          <div v-show="activeSection === 1" id="teamInfo" class="ps-team-embed">
            <TeamInfo
              :oldInfos="baseInfo"
              :isbj="isbjs"
              ref="teamInfoRef"
            />
          </div>
          <div v-show="activeSection === 2" id="budget">
            <SupplyStuff
              :oldInfos="baseInfo"
              ref="supplyRef"
              :isbj="isbjs"
            />
          </div>
        </div>

        <div class="ps-footer-bar">
          <div class="ps-footer-tip">
            💡 AI 已识别申报书内容，请核对后按步骤完善各模块
          </div>
          <div class="ps-footer-actions">
            <button type="button" class="ps-btn ps-btn--white" @click="editPrev">
              ← 上一步
            </button>
            <button type="button" class="ps-btn ps-btn--blue" @click="editNext">
              下一步 →
            </button>
            <button type="button" class="ps-btn ps-btn--blue" @click="option()">
              ✉ 提交
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInfo from "./baseInfo.vue";
import SupplyStuff from "./supplyStuff.vue";
import TeamInfo from "./teamInfo.vue";
import { getAction, postAction, putAction, deleteAction, postAiChat } from "@/api/index";
import AiParseLoading from "@/components/common/AiParseLoading.vue";
import StatusBadge from "@/components/projectShell/StatusBadge.vue";
import sectionFilledMixin from "@/components/projectShell/sectionFilledMixin.js";
import { WK } from "@/utils/brand.js";
import { emptyDatesToNull, emptyToNull } from "@/utils/time";
import axios from "axios";
export default {
  mixins: [sectionFilledMixin],
  name: "",
  components: {
    BaseInfo,
    TeamInfo,
    SupplyStuff,
    AiParseLoading,
    StatusBadge,
  },
  props: {
    editInfo: { type: Object, default: null },
    news: { type: String },
  },
  watch: {
    editInfo: {
      handler(newValue, oldValue) {
        // console.log(newValue, "8888888888888888");
        if (newValue !== null) {
          // this.baseInfo = newValue;
          // this.id = newValue.id;
          // this.$refs.baseInfoRef.info = newValue;
          // this.$refs.baseInfoRef.oldInfos = newValue;
          // this.$refs.teamInfoRef.oldInfos = newValue;
          // this.$refs.supplyRef.oldInfos=newValue;

          if (this.$store.state.role == "education-role") {
            this.isEdit = true;
            this.editInfo.type = "preview";
            this.isbjs = true;
          } else {
            if (
              this.baseInfo.auditState == 1 ||
              this.baseInfo.auditState == 2
            ) {
              this.isEdit = true;
              this.editInfo.type = "preview";
            } else {
              this.isEdit = false;
              this.editInfo.type = "";
            }
          }

          if (this.isbjs == false) {
            this.isEdit = false;
            this.editInfo.type = "";
          } else {
            // this.isEdit = true;
            // this.editInfo.type = "preview";
          }
          // this.baseInfo.isbjs=true;
        } else {
          // this.baseInfo = null;
          // this.id = null;
          // this.$refs.baseInfoRef.info = null;
          //  this.$refs.baseInfoRef.oldInfos = null;
          // this.$refs.teamInfoRef.oldInfos = null;
          // this.$refs.supplyRef.oldInfos=null;
          // this.isEdit = false;
          // this.editInfo.type = "";
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      isEdit: false,
      sections: [
        {
          title: "思政微课基本信息",
          id: "baseInfo",
        },
        {
          title: "团队成员",
          id: "teamInfo",
        },
        {
          title: "补充材料",
          id: "budget",
        },
      ],
      baseInfo: null,
      id: null,
      activeSection: 0,
      sectionRefMap: {
        teamInfo: "teamInfoRef",
        budget: "supplyRef",
      },

      isAction: false,
      isAdd: true,
      isbjs: true,
      educationlist: [],
      zclist: [],
      contentlist: [],
      kclists: [],
      jxing: true,
      fileId: "",
      isSubmit: false,
      draftLoading: false,
      aiChatCancelSource: null,
    };
  },
  computed: {},
  destroyed() {
    window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
  },
  created() {},
  methods: {
    async getkclists() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=course_type"
        );
        if (res.code == 200) {
          this.kclists = res.result;
        }
      } catch (error) {
        console.error("kclists 出错:", error);
      }
    },
    iskclist(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.kclists.length > 0) {
          let foundItem = this.kclists.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async getcontent() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=member_source"
        );
        if (res.code == 200) {
          this.contentlist = res.result;
        }
      } catch (error) {
        console.error("getcontent 出错:", error);
      }
    },
    iscontent(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.contentlist.length > 0) {
          let foundItem = this.contentlist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async getedu() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=education"
        );
        // console.log(res);
        if (res.code == 200) {
          this.educationlist = res.result;
        }
      } catch (error) {
        console.error("getedu 出错:", error);
      }
    },
    isedu(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.educationlist.length > 0) {
          let foundItem = this.educationlist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async getzc() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=professional"
        );
        if (res.code == 200) {
          this.zclist = res.result;
        }
      } catch (error) {
        console.error("getxl 出错:", error);
      }
    },
    iszc(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.zclist.length > 0) {
          let foundItem = this.zclist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    isbj() {
      //   console.log(this.editInfo, "2222");
      this.isbjs = false;
    },
    collectAiDraftData() {
      const info =
        (this.$refs.baseInfoRef && this.$refs.baseInfoRef.info) || {};
      const fileList =
        (this.$refs.baseInfoRef && this.$refs.baseInfoRef.fileList) || [];
      const supply = this.$refs.supplyRef;
      const payload = {
        ...(this.baseInfo || {}),
        ...info,
      };
      if (fileList.length > 0) {
        payload.declarationName = fileList[0].name;
        payload.declarationPath = fileList[0].path;
      }
      if (supply && supply.info) {
        payload.ideologicalElement = supply.info.ideologicalElement;
        payload.type = supply.info.type;
        if (
          supply.info.type == 0 &&
          supply.fileList &&
          supply.fileList.length > 0
        ) {
          payload.fileName = supply.fileList[0].name;
          payload.filePath = supply.fileList[0].path;
        } else {
          payload.fileName = supply.info.name;
          payload.filePath = supply.info.filePath;
        }
      }
      if (payload.applyYear) {
        payload.applyYear = this.isYear(payload.applyYear);
      }
      return payload;
    },
    saveDraft() {
      if (this.draftLoading || this.jxing) return;
      this.draftLoading = true;
      const params = this.buildCourseImportPayload();
      this.baseInfo = { ...(this.baseInfo || {}), ...params };
      postAction("/aiAuto/saveDraft", params)
        .then((res) => {
          if (res.code == 200 || res.success) {
            this.isSubmit = true;
            this.applyDraftId(res);
            this.$message.success(res.message || "暂存成功");
            this.$nextTick(() => {
              this.$router.replace({ name: "szMicroClass" }).catch(() => {
                this.$router.push({ name: "szMicroClass" });
              });
            });
          } else {
            this.$message.error(res.message || "暂存失败");
          }
        })
        .finally(() => {
          this.draftLoading = false;
        });
    },
    formatFoundTime(foundTime) {
      if (!foundTime) return null;
      const dateObj = new Date(foundTime);
      if (isNaN(dateObj.getTime())) return null;
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const date = dateObj.getDate();
      return `${year}-${month.toString().padStart(2, "0")}-${date
        .toString()
        .padStart(2, "0")}`;
    },
    applyDraftId(res) {
      const id = res && res.result && res.result.id;
      if (!id) return;
      if (!this.baseInfo) this.baseInfo = {};
      this.baseInfo.id = id;
      if (this.$refs.baseInfoRef && this.$refs.baseInfoRef.info) {
        this.$refs.baseInfoRef.info.id = id;
      }
      const userId =
        (this.$store.state.user && this.$store.state.user.id) ||
        this.$store.state.userId;
      if (userId) {
        window.sessionStorage.setItem(`step${userId}`, id);
      }
    },
    buildCourseImportPayload() {
      const info =
        (this.$refs.baseInfoRef && this.$refs.baseInfoRef.info) || {};
      const fileList =
        (this.$refs.baseInfoRef && this.$refs.baseInfoRef.fileList) || [];
      const supply = this.$refs.supplyRef;
      const supplyInfo = (supply && supply.info) || {};
      const fileList1 = (supply && supply.fileList) || [];
      let course = info.course;
      if (Array.isArray(course)) {
        course = course.join(",");
      }
      let applyYear = "";
      if (info.applyYear) {
        applyYear = this.isYear(info.applyYear);
        if (!applyYear) {
          const y = new Date(info.applyYear);
          applyYear = isNaN(y.getTime())
            ? String(info.applyYear)
            : y.getFullYear() + "";
        }
      }
      let ideologicalElement = supplyInfo.ideologicalElement;
      if (Array.isArray(ideologicalElement)) {
        ideologicalElement = ideologicalElement.join(",");
      }
      let fileName = supplyInfo.name;
      let filePath = supplyInfo.filePath;
      if ((supplyInfo.type == 0 || supplyInfo.type === "0") && fileList1.length > 0) {
        fileName = fileList1[0].name;
        filePath = fileList1[0].path;
      }
      const params = {
        applyType: 3,
        id: (this.baseInfo && this.baseInfo.id) || info.id,
        name: info.name,
        basicMajorCategory: info.basicMajorCategory,
        foundTime: this.formatFoundTime(info.foundTime),
        basicMajor: info.basicMajor,
        basicMajorSubclass: info.basicMajorSubclass,
        course,
        courseType: info.courseType,
        applyYear,
        declarationName: fileList[0] ? fileList[0].name : info.declarationName,
        declarationPath: fileList[0] ? fileList[0].path : info.declarationPath,
        wkStudyNum: info.wkStudyNum,
        levelType: info.levelType,
        teacherlist: (this.baseInfo && this.baseInfo.teacherlist) || [],
        ideologicalElement,
        fileName,
        filePath,
      };
      emptyDatesToNull(params);
      return params;
    },
    option() {
      console.log("this.baseInfo", this.baseInfo);
      console.log("this.$refs.supplyRef.info", this.$refs.supplyRef.info);
      let info = this.$refs.baseInfoRef.info;
      let fileList = this.$refs.baseInfoRef.fileList;
      let fileList1 = this.$refs.supplyRef.fileList;
      let ideologicalElement = this.$refs.supplyRef.info.ideologicalElement;
      if (info && info.name === "") {
        if (info.name === "" || info.name == undefined) {
          this.$message.info("请填写思政微课名称");
          return false;
        }
      } else if (
        (info && info.applyYear === "") ||
        info.applyYear == undefined
      ) {
        this.$message.info("请选择申报年份");
        return false;
      } else if (info && info.foundTime === "") {
        if (info.foundTime === "" || info.foundTime == undefined) {
          this.$message.info("请选择创建时间");
          return false;
        }
      }

      if (info && info.basicMajorCategory === "") {
        if (
          info.basicMajorCategory === "" ||
          info.basicMajorCategory == undefined
        ) {
          this.$message.info("请选择专业大类");
          return false;
        }
      }
      // if (info && info.basicMajorSubclass === "") {
      //   if (
      //     info.basicMajorSubclass === "" ||
      //     info.basicMajorSubclass == undefined
      //   ) {
      //     this.$message.info("请选择专业子类");
      //     return false;
      //   }
      // }

      // if (info && info.basicMajor === "") {
      //   if (info.basicMajor === "" || info.basicMajor == undefined) {
      //     this.$message.info("请选择专业");
      //     return false;
      //   }
      // }
      if (info && info.course.length == "0") {
        if (info.course.length == "0" || info.course == undefined) {
          this.$message.info("请选择课程");
          return false;
        }
      }
      if ((info && info.courseType === "") || info.courseType == undefined) {
        this.$message.info("请选择课程类型");
        return false;
      }

      if ((info && info.wkStudyNum === "") || info.wkStudyNum == undefined) {
        this.$message.info("请输入学习人次");
        return false;
      }
      if ((info && info.levelType === "") || info.levelType == undefined) {
        this.$message.info("请选择级别");
        return false;
      }
      if (fileList.length == 0) {
        this.$message.info("请上传申报书");
        return false;
      }
      if (
        !this.baseInfo.teacherlist ||
        this.baseInfo.teacherlist.length === 0
      ) {
        this.$message.info("请添加团队成员");
        return false;
      }
      if (this.baseInfo.teacherlist.length > 0) {
        const requiredFields = [
          "teacherName",
          "sex",
          "birthday",
          "professionalTitle",
          "izPolitical",
          "izResponse",
          "joinYear",
          "memberSource",
        ];
        for (let i = 0; i < this.baseInfo.teacherlist.length; i++) {
          const item = this.baseInfo.teacherlist[i];

          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "teacherName") {
                this.$message.info(`第 ${i + 1} 行的教师姓名没有值，请填写`);
                return; // 退出当前函数，停止进一步处理
              } else if (field == "sex") {
                this.$message.info(`第 ${i + 1} 行的教师性别没有值，请填写`);
                return; // 退出当前函数，停止进一步处理
              } else if (field == "birthday") {
                this.$message.info(`第 ${i + 1} 行的出生日期没有值，请填写`);
                return; // 退出当前函数，停止进一步处理
              } else if (field == "professionalTitle") {
                this.$message.info(`第 ${i + 1} 行的职称没有值，请填写`);
                return;
              } else if (field == "izPolitical") {
                this.$message.info(
                  `第 ${i + 1} 行的是否思政老师没有值，请填写`
                );
                return;
              } else if (field == "izResponse") {
                this.$message.info(`第 ${i + 1} 行的是否负责人没有值，请填写`);
                return;
              } else if (field == "joinYear") {
                this.$message.info(`第 ${i + 1} 行的加入年份没有值，请填写`);
                return;
              } else if (field == "memberSource") {
                this.$message.info(`第 ${i + 1} 行的成员来源没有值，请填写`);
                return;
              }
            }
          }
        }
      }
      if (this.$refs.supplyRef.info.type == 0) {
        if (fileList1.length == 0) {
          this.$message.info("请上传思政微课视频");
          return false;
        }
      }
      if (this.$refs.supplyRef.info.type == 1) {
        if (
          !this.$refs.supplyRef.info.name ||
          this.$refs.supplyRef.info.name.trim() === ""
        ) {
          this.$message.info("请输入超链接名称");
          return false;
        }
        if (
          !this.$refs.supplyRef.info.filePath ||
          this.$refs.supplyRef.info.filePath.trim() === ""
        ) {
          this.$message.info("请输入超链接地址");
          return false;
        }
      }
      if (ideologicalElement.length == 0) {
        this.$message.info("请选择思政元素");
        return false;
      }
      const params = this.buildCourseImportPayload();
      console.log(params);
      this.loading = true;
      postAction("/aiAuto/autoImport", params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.isSubmit = true;
          this.$message.success("提交成功");
          this.$router.replace({ name: "szMicroClass" }).catch(() => {
            this.$router.push({ name: "szMicroClass" });
          });
          // console.log("haole");
        } else {
          this.$message.error(res.message);
        }
        this.loading = false;
      });
      // this.loading = true;
      // let arr = [];
      // arr.push(this.baseInfo.id);
      // let data = {
      //   applyIds: arr,
      // };
      // postAction("/lx/lxApply/submitBatch", data).then((res) => {
      //   console.log(res);
      //   if (res.code === 200) {
      //     this.$router.push({ name: "szStudio" });
      //   } else {
      //     this.$message.info(res.message);
      //   }
      //   this.loading = false;
      // });
    },
    goStep(item) {
      console.log("item", item);
      this.baseInfo = item;
      this.editInfo = item;
    },
    editGo(index) {
      this.activeSection = index;
      this.$nextTick(() => this.refreshSectionFilled());
    },
    editPrev() {
      if (this.activeSection > 0) {
        this.editGo(this.activeSection - 1);
      }
    },
    editNext() {
      if (this.activeSection < this.sections.length - 1) {
        this.editGo(this.activeSection + 1);
      }
    },
    goBack() {
      this.$router.push({ name: "szMicroClass" });
    },
    // 获取暂存数据
    getTemporaryStorage() {
      postAction("/lx/lxApply/getAiData?applyType=3").then((res) => {
        console.log("res", res);
        if (res.code == 200) {
          this.baseInfo =
            (res.result && res.result.jsonObject) || res.result || {};
          this.jxing = false;
          this.$nextTick(() => {
            this.fillAiFormFromBaseInfo();
          });
        }
      });
    },

    normalizeAiTagList(value) {
      if (value == null || value === "") return [];
      let list = [];
      if (Array.isArray(value)) {
        list = value.map((v) => (v == null ? "" : String(v).trim()));
      } else {
        const s = String(value).trim();
        if (!s) return [];
        list = s.indexOf(",") > -1 ? s.split(",") : [s];
        list = list.map((x) => String(x).trim());
      }
      return list.filter(Boolean).slice(0, 50);
    },
    fillAiFormFromBaseInfo() {
      if (!this.$refs.baseInfoRef || !this.baseInfo) return;
      const src = this.baseInfo;
      if (src.applyYear) {
        src.applyYear = this.isYear(src.applyYear);
      }
      const info = this.$refs.baseInfoRef.info || {};
      info.name = src.name || "";
      info.applyYear = src.applyYear || "";
      info.foundTime = src.foundTime || "";
      info.basicMajorCategory = src.basicMajorCategory || "";
      info.basicMajorSubclass = src.basicMajorSubclass || "";
      info.basicMajor = src.basicMajor || "";
      info.course = this.normalizeAiTagList(src.course);
      info.courseType = src.courseType || "";
      info.wkStudyNum = src.wkStudyNum || "";
      info.levelType = src.levelType || "";
      info.applyType = 3;
      info.declarationName = src.declarationName || "";
      info.declarationPath = src.declarationPath || "";
      if (src.id) info.id = src.id;
      // 必须写到子组件自己的 info 对象上，不能把 baseInfo 整份赋过去。
      // 否则 info 和 oldInfos 变成同一引用，deep watch 会把 course 来回改导致卡死。
      this.$refs.baseInfoRef.info = info;
      const fileList = [];
      if (src.declarationPath || src.declarationName) {
        fileList.push({
          path: src.declarationPath || "",
          name: src.declarationName || "",
          uid: 1,
        });
      }
      this.$refs.baseInfoRef.fileList = fileList;
      if (this.$refs.baseInfoRef.normalizeApplyYear) {
        this.$refs.baseInfoRef.normalizeApplyYear();
      }
      if (this.$refs.supplyRef && this.$refs.supplyRef.info) {
        if (src.ideologicalElement) {
          this.$refs.supplyRef.info.ideologicalElement =
            this.normalizeAiTagList(src.ideologicalElement);
        }
        if (src.type !== undefined && src.type !== null) {
          this.$refs.supplyRef.info.type = src.type;
        }
        if (src.fileName || src.filePath) {
          this.$refs.supplyRef.info.name = src.fileName;
          this.$refs.supplyRef.info.filePath = src.filePath;
          if (src.type == 0 || src.type === "0") {
            this.$refs.supplyRef.fileList = [
              {
                name: src.fileName || "",
                path: src.filePath || "",
                uid: 1,
              },
            ];
          }
        }
      }
    },

    getsj() {
      if (this.$route.query.new == "ai") {
        this.jxing = true;
        if (this.aiChatCancelSource) {
          this.aiChatCancelSource.cancel("restart");
        }
        this.aiChatCancelSource = axios.CancelToken.source();
        postAiChat(
          {
            fileId: this.fileId,
            applyType: 3,
            chatType: this.$route.query.chatType,
            filePath: this.$route.query.filePath,
          },
          { cancelToken: this.aiChatCancelSource.token }
        )
          .then((res) => {
          if (res && res.code == 200) {
            let str = res.result;
            if (typeof str === "string") {
              try {
                const extracted = this.extractJsonContent(str);
                str = JSON.parse(
                  extracted !== "No JSON content found" ? extracted : str
                );
              } catch (e) {
                this.$message.error("智能识别结果解析失败，请稍后重试");
                this.$router.go(-1);
                return;
              }
            }
            this.sj = str;
            const base = (str && str.思政微课基本信息) || {};
            let datas = {
              name: "",
              applyYear: "",
              foundTime: "",
              basicMajorCategory: "",
              basicMajorSubclass: "",
              basicMajor: "",
              course: [],
              courseType: "",
              wkStudyNum: "",
              levelType: "",
              teacherlist: [],
              applyType: 3,
              declarationName: "",
              declarationPath: "",
              ideologicalElement: [],
            };
            datas.name = base.思政微课名称 || "";
            datas.applyYear = base.申报年份 ? this.isYear(base.申报年份) : "";
            datas.course = this.normalizeAiTagList(base.所属课程);
            datas.courseType = base.课程类型 ? this.iskclist(base.课程类型) : "";
            datas.levelType = base.级别 || "";
            datas.foundTime = base.创建时间
              ? emptyToNull(this.isTime(base.创建时间))
              : null;
            datas.wkStudyNum = base.学习人次 || "";
            datas.declarationName = this.$route.query.fileName;
            datas.declarationPath = this.$route.query.filePath;
            if (
              str &&
              str.思政微课团队成员 &&
              str.思政微课团队成员.length > 0
            ) {
              datas.teacherlist = str.思政微课团队成员.reduce(
                (accumulator, student, index) => {
                  accumulator.push({
                    teacherName:
                      student.教师姓名 == undefined ? "" : student.教师姓名,
                    id: student.教师姓名 + index,
                    sex: student.性别 == undefined ? "男" : student.性别,
                    birthday:
                      student.生日 == undefined
                        ? null
                        : emptyToNull(this.isTime(student.生日)),
                    degree:
                      student.学历 == undefined ? "" : this.isedu(student.学历),
                    professionalTitle:
                      student.职称 == undefined ? "" : this.iszc(student.职称),
                    major:
                      student.从事专业 == undefined ? "" : student.从事专业,
                    joinYear:
                      student.加入年份 == undefined
                        ? ""
                        : this.isYear(student.加入年份),
                    primaryMission:
                      student.主要任务 == undefined ? "" : student.主要任务,
                    izResponse:
                      student.是否负责人 == undefined
                        ? "否"
                        : student.是否负责人,
                    izPolitical:
                      student.是否思政教师 == undefined
                        ? "否"
                        : student.是否思政教师,
                    memberSource:
                      student.成员来源 == undefined
                        ? ""
                        : this.iscontent(student.成员来源),
                  });
                  return accumulator;
                },
                []
              );
            }
            datas.ideologicalElement = this.normalizeAiTagList(str && str.思政元素);
            this.baseInfo = datas;
          } else {
            this.$message.error(
              (res && res.message) || "智能识别失败，请稍后重试"
            );
            this.$router.go(-1);
          }
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            return;
          }
          console.error("AI识别失败:", err);
          const msg =
            (err && err.message) ||
            (err &&
              err.response &&
              err.response.data &&
              err.response.data.message) ||
            "智能识别失败，请稍后重试";
          this.$message.error(msg);
          this.$router.go(-1);
        })
        .finally(() => {
          this.aiChatCancelSource = null;
          this.jxing = false;
          this.$nextTick(() => {
            this.fillAiFormFromBaseInfo();
          });
        });
      }
    },
    cancelAiParse() {
      if (this.aiChatCancelSource) {
        this.aiChatCancelSource.cancel("user_cancel");
        this.aiChatCancelSource = null;
      }
      this.jxing = false;
      this.$message.info("已取消智能识别");
      this.$router.go(-1);
    },
    isNumber(value) {
      if (/^-?\d+(\.\d+)?$/.test(value)) {
        return value;
      } else {
        return "";
      }
    },
    isYear(year) {
      if (year === null || year === undefined || year === "") return "";
      if (typeof year === "object" && !Array.isArray(year) && typeof year.year === "function") {
        const y = year.year();
        return y ? String(y) : "";
      }
      if (Array.isArray(year)) {
        for (let i = 0; i < year.length; i++) {
          const y = this.isYear(year[i]);
          if (y) return y;
        }
        return "";
      }
      const s = String(year).trim();
      if (/^\d{4}$/.test(s)) return s;
      const m = s.match(/(20\d{2}|19\d{2})/);
      if (m) return m[1];
      const d = new Date(year);
      return isNaN(d.getTime()) ? "" : String(d.getFullYear());
    },
    isTime(time) {
      if (time) {
        if (time.length == "10") {
          return time;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    extractJsonContent(content) {
      // 正则表达式匹配 JSON 内容
      const pattern = /```json\n([\s\S]*?)\n```/; // /s 修饰符使 . 匹配换行符
      const match = content.match(pattern);
      if (match && match[1]) {
        return match[1].trim(); // 获取匹配到的 JSON 内容并去掉前后空格
      } else {
        return "No JSON content found";
      }
    },
    async executeSequentially() {
      try {
        await this.getkclists();
        await this.getedu();
        console.log("getedu 执行完毕");
        await this.getzc();
        console.log("getxl 执行完毕");
        await this.getcontent();
        console.log("getcontent 执行完毕");
        this.getsj();
      } catch (error) {
        console.log("发生错误:", error);
      }
    },
  },
  mounted() {
    this.fileId = this.$route.query.id;
    // console.log(this.editInfo,'我是editInfo')
    // if (this.editInfo !== null) {
    //   console.log("this.editInfo mounted", this.editInfo);
    //   this.baseInfo = this.editInfo;
    //   this.id = this.editInfo.id;
    //   this.$refs.baseInfoRef.info = this.editInfo;
    //   this.$refs.teamInfoRef.oldInfo = this.editInfo;
    // }
    this.isAdd = this.$route.query.new;
    // 有id 是ai导入  无id 是暂存数据
    if (this.$route.query.new == "ai" && this.$route.query.id) {
      this.executeSequentially();
    } else {
      this.getTemporaryStorage();
    }
  },
  beforeDestroy() {
    if (this.aiChatCancelSource) {
      this.aiChatCancelSource.cancel("leave");
      this.aiChatCancelSource = null;
    }
    if (!this.isSubmit) {
      postAction("/lx/lxApply/saveAiData?applyType=3", {
        jsonObject: this.collectAiDraftData(),
      }).then((res) => {
        if (res.code == 200) {
          //this.$message.success("暂存成功");
        }
      });
    }
  },
};
</script>
  
<style scoped lang="scss">
@import "@/components/projectShell/updatePage.scss";

.ps-update-page.is-ai-parsing {
  min-height: 560px;
  position: relative;
}
</style>
  